import Controller from '../core/Controller';
import LibraryView from '../view/LibraryView';
import FolderView from '../view/FolderView';
import PDFView from '../view/PDFView';
import YoutubeView from '../view/video/YoutubeView';
import YoutubeListView from '../view/video/YoutubeListView';
import VimeoView from '../view/video/VimeoView';
import LocalVideoView from '../view/video/LocalVideoView';
import WebView from '../view/web/WebView';
import TypeformView from '../view/web/TypeformView';
import GoogleMapsView from '../view/web/GoogleMapsView';
import HTMLView from '../view/web/HTMLView';
import URLUtils from '../util/URLUtils';
import LibraryCatalogFilter from '../util/LibraryCatalogFilter';
import LibraryCatalogSorter from '../util/LibraryCatalogSorter';
import LibraryXMLParser from '../parser/LibraryXMLParser';

export default class LibraryController extends Controller {

    constructor() {
        super();
    }

    onRegistered() {
        this.registerAction('loadLibrary', this.loadLibrary.bind(this));
        this.registerAction('loadLibraryCatalog', this.loadLibraryCatalog.bind(this));
        this.registerAction('searchLibraryCatalogs', this.searchLibraryCatalogs.bind(this));
    }

    loadLibrary(args) {
        let library = args['library'];

        // Check useAsRoot
        let useAsRootCatalogs = this.getUseAsRootCatalogs(library.catalogList);
        useAsRootCatalogs = LibraryCatalogFilter.filter(useAsRootCatalogs, {
            'deviceType': this.app.currentDeviceType,
            'deviceLanguage': this.app.currentDeviceLanguage
        });

        if (useAsRootCatalogs.length > 0) {
            this.loadLibraryCatalog({
                'libraryCatalog': useAsRootCatalogs[0]
            });
        } else {
            let catalogList = library.catalogList;
            catalogList = LibraryCatalogFilter.filter(catalogList, {
                'deviceType': this.app.currentDeviceType,
                'deviceLanguage': this.app.currentDeviceLanguage
            });
            catalogList = LibraryCatalogSorter.sort(catalogList, this.app.library.indexSortType);

            if (library.singleIssueApp) {
                catalogList[0].useAsRoot = true;
                this.loadLibraryCatalog({
                    'libraryCatalog': catalogList[0]
                });
            } else {
                this.getApp().renderView(new LibraryView(), {
                    'library': library,
                    'catalogList': catalogList
                });
            }
        }
    }

    loadLibraryCatalog(args) {
        let libraryCatalog = args['libraryCatalog'];
        console.log(libraryCatalog);

        if (libraryCatalog.catalogType == 'FOLDER') {
            let catalogList = libraryCatalog.childList;
            catalogList = LibraryCatalogFilter.filter(catalogList, {
                'deviceType': this.app.currentDeviceType,
                'deviceLanguage': this.app.currentDeviceLanguage
            });
            catalogList = LibraryCatalogSorter.sort(catalogList, this.app.library.indexSortType);

            this.getApp().renderView(new FolderView(), {
                'library': this.app.library,
                'baseUrl': this.app.baseUrl,
                'visualTemplate': this.app.visualTemplate,
                'libraryCatalog': libraryCatalog,
                'catalogList': catalogList
            });
        } else if (libraryCatalog.catalogType == 'INTELLIGENT_FOLDER') {

            $.get(libraryCatalog.intelligentFolderUrl, (data) => {

                let parser = new LibraryXMLParser();
                let intelligentFolder = parser.parseIntelligentFolder(data, this.app.visualTemplate);
                let catalogList = intelligentFolder.childList;
                catalogList = LibraryCatalogFilter.filter(catalogList, {
                    'deviceType': this.app.currentDeviceType,
                    'deviceLanguage': this.app.currentDeviceLanguage
                });
                catalogList = LibraryCatalogSorter.sort(catalogList, this.app.library.indexSortType);

                this.getApp().renderView(new FolderView(), {
                    'library': this.app.library,
                    'baseUrl': this.app.baseUrl,
                    'visualTemplate': this.app.visualTemplate,
                    'libraryCatalog': libraryCatalog,
                    'catalogList': catalogList
                });

            });

        } else if (libraryCatalog.catalogType == 'PDF') {

            let url = libraryCatalog.path;
            if (url.search('http') < 0) {
                let path = this.app.baseUrl + libraryCatalog.path;
                url = URLUtils.getURL(path);
            }

            this.getApp().renderView(new PDFView(), {
                'libraryCatalog': libraryCatalog,
                'url': url,
                'visualTemplate': this.app.visualTemplate
            });

        } else if (libraryCatalog.catalogType == 'INTERACTIVE') {
            let interactiveCatalogController = this.app.getController("InteractiveCatalogController");
            interactiveCatalogController.load(libraryCatalog);
        } else if (libraryCatalog.catalogType == 'VIDEO') {

            let args = {
                'library': this.app.library,
                'baseUrl': this.app.baseUrl,
                'visualTemplate': this.app.visualTemplate,
                'libraryCatalog': libraryCatalog
            };

            switch (libraryCatalog.catalogVideoType) {
                case 'YOUTUBE':
                    this.getApp().renderView(new YoutubeView(), args);
                    break;
                case 'YOUTUBE_LIST':
                    this.getApp().renderView(new YoutubeListView(), args);
                    break;
                case 'VIMEO':
                    this.getApp().renderView(new VimeoView(), args);
                    break;
                case 'LOCAL_VIDEO':
                    this.getApp().renderView(new LocalVideoView(), args);
                    break;
            }
        } else if (libraryCatalog.catalogType == 'WEB') {

            let args = {
                'library': this.app.library,
                'baseUrl': this.app.baseUrl,
                'visualTemplate': this.app.visualTemplate,
                'libraryCatalog': libraryCatalog
            };

            switch (libraryCatalog.catalogWebType) {
                case 'WEB':
                    this.getApp().renderView(new WebView(), args);
                    break;
                case 'TYPEFORM':
                    this.getApp().renderView(new TypeformView(), args);
                    break;
                case 'GOOGLE_MAPS':
                    this.getApp().renderView(new GoogleMapsView(), args);
                    break;
                case 'HTML':
                    this.getApp().renderView(new HTMLView(), args);
                    break;
                case 'FACEBOOK':
                    this.getApp().renderView(new HTMLView(), args);
                    break;
                case 'TWITTER':
                    this.getApp().renderView(new HTMLView(), args);
                    break;
                case 'RSS':
                    this.getApp().renderView(new WebView(), args);
                    break;
            }
        }


    }

    searchLibraryCatalogs(args) {
        let searchString = args['searchString'];

        let catalogList = this.app.library.getRecursiveCatalogList();
        catalogList = LibraryCatalogFilter.filter(catalogList, {
            'deviceType': this.app.currentDeviceType,
            'deviceLanguage': this.app.currentDeviceLanguage,
            'title': searchString
        });
        catalogList = LibraryCatalogSorter.sort(catalogList, this.app.library.indexSortType);

        this.getApp().renderView(new FolderView(), {
            'library': this.app.library,
            'baseUrl': this.app.baseUrl,
            'visualTemplate': this.app.visualTemplate,
            'libraryCatalog': {
                'title': searchString,
                'useAsRoot': false,
                'showCatalogMenu': true,
                'showExitButton': true
            },
            'catalogList': catalogList
        });
    }

    getUseAsRootCatalogs(catalogList) {

        let res = catalogList.filter((elem) => {
            return elem.useAsRoot;
        });

        catalogList.forEach((elem) => {
            res.concat(elem.childList);
        });

        return res;

    }

}